<template>
  <transition name="fade">
    <div>
      <div class="text-center">
        <!-- @slot Add your own loader. This is text-centered. -->
        <slot name="loader">
          <d-loader :type="loaderType" :size="30" />
        </slot>
      </div>

      <div class="mt-1 text-center">
        <!-- @slot Add your own heading. This is text-centered. -->
        <slot name="heading">
          <h5>
            Loading...
          </h5>
        </slot>
      </div>

      <div class="mt-2 text-center">
        <!-- @slot Add your own body. This is text-centered. -->
        <slot name="body">
          <p>
            Please wait while we prepare everything.
          </p>
        </slot>
      </div>
    </div>
  </transition>
</template>

<script>
  import DLoader from '../../elements/DLoader/DLoader.vue';

  /**
  * @displayName LoadingState
  */

  export default {
    name: 'DLoadingState',
    status: 'prototype',
    release: '0.1.0',
    components: { DLoader },

    props: {
      /**
       * `dots, spinner`
       */
      loaderType: {
        type: String,
        default: 'spinner',
      },
    },

    data: () => ({
      //
    }),

    computed: {
      dynamicClasses() {
        return {
          [`bg-${this.color}-500 text-white font-bold py-2 px-4 rounded`]: true, // Default Classes
          [`hover:bg-${this.color}-600`]: !this.disabled,
          'cursor-not-allowed opacity-50': this.disabled,
        };
      },
    },
  };
</script>
